import { useRef } from "react";
import Hero from "@/components/home/Hero";
import MetiersMarquee from "@/components/home/MetiersMarquee";
import Problem from "@/components/home/Problem";
import FeaturesGrid from "@/components/home/FeaturesGrid";
import DashboardKpis from "@/components/home/DashboardKpis";
import Operations from "@/components/home/Operations";
import MultiSites from "@/components/home/MultiSites";
import ForWho from "@/components/home/ForWho";
import PricingCards from "@/components/PricingCards";
import Addons from "@/components/Addons";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { usePageMeta } from "@/utils/pageMeta";
import { useTrackOnVisible } from "@/utils/analytics";

const Home = () => {
  const pricingRef = useRef(null);
  useTrackOnVisible(pricingRef, "view_pricing", { location: "home" });
  usePageMeta(
    "ActiPilote — Logiciel de gestion pour activités touristiques et de loisirs",
    "Gérez vos réservations, planning, caisse, dépenses, flotte, équipe et statistiques avec ActiPilote, la plateforme tout-en-un des professionnels du loisir."
  );

  return (
    <>
      <Hero />
      <MetiersMarquee />
      <Problem />
      <FeaturesGrid />
      <DashboardKpis />
      <Operations />
      <MultiSites />
      <ForWho />
      <section ref={pricingRef} data-testid="home-pricing-section" id="tarifs" className="scroll-mt-24 py-16 sm:py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-2xl text-center">
            <Eyebrow index="07">Tarifs</Eyebrow>
            <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
              Une offre adaptée à votre structure.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
              Des offres simples, adaptées à la taille de votre activité. Commencez avec l'essentiel et faites évoluer ActiPilote avec votre entreprise.
            </p>
          </Reveal>
          <div className="mt-14">
            <PricingCards />
          </div>
        </div>
      </section>
      <Addons />
      <Faq />
      <FinalCta />
    </>
  );
};

export default Home;
